import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Order, ValuationType, AppraisalType, PhoneType } from '../../models/order';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CrmAlertComponent } from '../crm-alert/crm-alert.component';
import { AuthProvider } from '../../providers/auth.provider';
import { LibOrderProvider } from '../../providers/order.provider';
import { LogService } from 'src/app/services';

@Component({
  selector: 'order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})

export class OrderDetailComponent implements OnInit {

  @Input() OrderId: any = null;

  /** Login Variables - START */
  @ViewChild('alert') alert: CrmAlertComponent;
  loginForm: FormGroup;
  authForm: FormGroup;
  loading = false;
  returnUrl: string;
  tfaFlag = false;
  /** Login Variables - END */

  isViewMode:boolean = true;
  sameAsIndividual: boolean = false;
  order:Order = new Order();
  showOrderDetail: boolean = false;
  jwtHelper: JwtHelperService = new JwtHelperService();
  displayLoginScreen: boolean = false;
  showDragHandle: boolean = false;

  // Enums
  ValuationType = ValuationType;
  AppraisalType = AppraisalType;
  PhoneType = PhoneType;

  constructor(
    private fb: FormBuilder,
    private authProvider: AuthProvider,
    private orderProvider: LibOrderProvider,
    private logService : LogService
  ) {
    this.loginForm = this.fb.group({
      USER_EMAIL: [null, Validators.compose([Validators.required, Validators.pattern('[^ @]*@[^ @]*')])],
      USER_PASSWORD: [null, Validators.compose([Validators.required, Validators.minLength(8)])]
    });

    this.authForm = this.fb.group({
      AUTH_CODE: [null, Validators.required]
    });
  }

  ngOnInit(): void {
  }

  // ngOnDestroy() - When page is destroy do action.
  ngOnDestroy(): void {

  }

  // trackByFn() - Track by function for company name.
  trackByFn(index, item): any {
    return (item.id);
  }

  /** Display order detail */
  openOrder(): void{
    if(this.checkShellToken()){
      this.getOrderDetail();
    }else{
      this.displayLoginScreen = true;
      setTimeout(() => {
        this.draggable(document.getElementById('drag-picker'), document.getElementById('order-login'));
      }, 0);
    }
  }

  /** Add Company */
  addCompanyName(): void{
    this.order.COMPANY_NAME.push('');
  }

  /** Remove Company Name */
  removeCompanyName(index: number): void{
    this.order.COMPANY_NAME.splice(index, 1);
  }

  /** Hide order detail */
  hideOrderDetail(): void{
    this.showOrderDetail = false;
  }

  /** Close login screen */
  closeLoginScreen(): void{
    this.displayLoginScreen = false;
    this.loginForm.reset();
  }

  /** Check user is logged in shell module or not */
  checkShellToken(): boolean{
    const token = localStorage.getItem('R-SHELL-TOKEN');
    if (token != null) {
      if (this.jwtHelper.isTokenExpired(token)) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  /** Draggable funciton for order detail div */
  draggable(el, el1) {
    let offsetX;
    let offsetY;
    el.addEventListener('mousedown', function(e) {

      offsetX = e.clientX - parseInt(window.getComputedStyle(this).left);
      offsetY = e.clientY - parseInt(window.getComputedStyle(this).top);

      function mouseMoveHandler(e) {

        el1.style.top = (e.clientY - offsetY) + 'px';
        el1.style.left = (e.clientX - offsetX) + 'px';

        el.style.top = (e.clientY - offsetY) + 'px';
        el.style.left = (e.clientX - offsetX) + 'px';
      }

      function reset() {
        window.removeEventListener('mousemove', mouseMoveHandler);
        window.removeEventListener('mouseup', reset);
      }
      window.addEventListener('mousemove', mouseMoveHandler);
      window.addEventListener('mouseup', reset);

    });
  }

  /** Get Order Detail */
  getOrderDetail(): void{
    this.loading = true;
    this.orderProvider.getOrder(this.OrderId)
    .subscribe(response => {
      this.loading = false;
      if (response.success) {
        this.order = Order.parse(response.result);
        this.showOrderDetail = !this.showOrderDetail;
        setTimeout(() => {
          this.draggable(document.getElementById('drag-picker'), document.getElementById('order-detail-drag'));
        }, 0);
      }
    }, err => {
      this.logService.error(err);
      this.loading = false;
    });
  }

  /** Login submit */
  onLoginSubmit(): void {
    this.alert?.hide();
    if (this.loginForm.valid) {
      this.loading = true;
      const loginDetails = this.loginForm.value;

      this.authProvider.authenticate(loginDetails.USER_EMAIL, loginDetails.USER_PASSWORD)
        .subscribe(response => {
          if (response.success) {
            this.loading = false;

            if (response.result.profile.TWO_FACTOR_ENABLE) {
              this.tfaFlag = true;
            } else {
              this.loginForm.reset();
              this.navigate(response);
            }

          } else {
            this.loading = false;
            this.alert?.show(response.error);
          }
        }, err => {
          this.logService.error(err);
          this.alert?.showError(err.message);
          this.loading = false;
        });
    }
  }

  /** Auth submit */
  onAuthSubmit(): void {
    if (this.authForm.valid) {
      this.loading = true;

      this.authProvider.verifyAuthCode(this.loginForm.value.USER_EMAIL,
        this.loginForm.value.USER_PASSWORD,
        this.authForm.value.AUTH_CODE)
        .subscribe(data => {
          if (data.success) {
            this.loading = false;
            this.authForm.reset();
            this.loginForm.reset();
            this.navigate(data);
          } else {
            this.loading = false;
            this.alert.show(data.error);
          }
      }, (error: any) => {
        this.logService.error(error);
        this.alert.showError(error.message);
        this.loading = false;
      });
    }
  }

  /** After login display order detail page */
  navigate(data: any): void {
    localStorage.setItem('R-SHELL-TOKEN', data.result.token);
    localStorage.setItem('R-SHELL-PROFILE', JSON.stringify(data.result.profile));
    this.displayLoginScreen = false;
    this.showOrderDetail = true;
    setTimeout(() => {
      this.draggable(document.getElementById('drag-picker'), document.getElementById('order-detail-drag'));
    }, 0);
  }
}
